/**
 * Which Lab catalog entries also live in the priorities.ai product surface
 * (Prioritization, Planning, Mandate, Brief, or lab aliases of those features).
 */
const PRIORITIES_PRODUCT_PREFIXES = [
  '/prioritization',
  '/planning',
  '/apps/mandate',
  '/brief',
] as const;

/** Lab paths that wrap or archive priorities.ai product features. */
const PRIORITIES_PRODUCT_LAB_PATHS = new Set([
  '/lab/judgment-index',
  '/lab/cognitive-bias',
  '/lab/lexicon',
  '/lab/prioritization-archive/security',
  '/lab/prioritization-archive/goals',
]);

export function isInPrioritiesProduct(path: string): boolean {
  if (path.startsWith('http://') || path.startsWith('https://')) return false;
  if (PRIORITIES_PRODUCT_LAB_PATHS.has(path)) return true;
  return PRIORITIES_PRODUCT_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export const PRIORITIES_PRODUCT_SIGNIFIER = {
  label: 'Also in priorities.ai',
  shortLabel: 'priorities.ai',
} as const;
